class ProductMediaBadges extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-goto-video]')?.addEventListener('click', () => this.#goToVideo());
    this.querySelector('[data-goto-usage-videos]')?.addEventListener('click', (event) => {
      event.preventDefault();
      this.#goToUsageVideos();
    });
  }

  #goToVideo() {
    const index = parseInt(this.dataset.videoIndex || '-1', 10);
    if (index < 0) return;

    const gallery = this.closest('media-gallery');
    const slideshow = gallery?.slideshow;
    if (slideshow?.select) {
      slideshow.select(index, undefined, { animate: true });
    }

    const slide = gallery?.querySelector(`slideshow-slide:nth-child(${index + 1})`);
    const video = slide?.querySelector('video, iframe, deferred-media');
    if (video instanceof HTMLVideoElement) {
      video.play().catch(() => {});
    } else if (video && 'loadContent' in video && typeof video.loadContent === 'function') {
      video.loadContent();
    }
  }

  #goToUsageVideos() {
    const target = document.getElementById('kullanim-videolari');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    try {
      history.replaceState(null, '', '#kullanim-videolari');
    } catch {
      /* */
    }
  }
}

if (!customElements.get('product-media-badges')) {
  customElements.define('product-media-badges', ProductMediaBadges);
}
